import clsx from "clsx";
import React, { TableHTMLAttributes } from "react";
import { useTheme } from "../../hooks";
import { TableThemeType } from "../../types";
import TableBody, { TableBodyProps } from "./TableBody";
import TableHead, { TableHeadProps } from "./TableHead";
import TableHeader, { TableHeaderProps } from "./TableHeader";
import TableRow, { TableRowProps } from "./TableRow";
import { TableStyled } from "./TableStyles";
import TableTd, { TableTdProps } from "./TableTd";
import TableTdInfo, { TableTdInfoProps } from "./TableTdInfo";

type TableProps = TableHTMLAttributes<HTMLTableElement> & {
  /** className to apply */
  className?: string;
  /** overrideable styles */
  styles?: TableThemeType;
};

export interface TableType extends React.FC<React.PropsWithChildren<TableProps>> {
  Header: React.FC<React.PropsWithChildren<TableHeaderProps>>;
  Head: React.FC<React.PropsWithChildren<TableHeadProps>>;
  Body: React.FC<React.PropsWithChildren<TableBodyProps>>;
  Row: React.FC<React.PropsWithChildren<TableRowProps>>;
  Td: React.FC<React.PropsWithChildren<TableTdProps>>;
  TdInfo: React.FC<React.PropsWithChildren<TableTdInfoProps>>;
}

const Table: TableType = ({ children, styles = {}, className, ...rest }) => {
  const { Theme } = useTheme();
  const StylesOverride: TableThemeType = { ...Theme.table, ...styles };

  return (
    <TableStyled
      styles={StylesOverride}
      className={clsx(className, "table table-sm table-bordered", "best-table")}
      {...rest}
    >
      {children}
    </TableStyled>
  );
};

Table.Header = TableHeader;
Table.Td = TableTd;
Table.TdInfo = TableTdInfo;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Head = TableHead;

export default Table;
